import { useState, useEffect } from "react";
import { FiClock, FiPhone, FiUser, FiSmile } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import PulseLoader from "./Utility/PulseLoader";
import InfiniteScroll from 'react-infinite-scroll-component';

function ClinicPatientsGrid({  isLoading, isSuccess, isFetching, getPatients, selectedFilters  }) {
  const navigate = useNavigate();
   const location = useLocation();
  
  const [patients, setPatients] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);


    function convertFilters(selectedFilters) {
    if (!selectedFilters) return [];
    return Object.entries(selectedFilters).map(([key, valueSet]) => ({
      filterName: key,
      filterOperator: valueSet.operator,
      filterValue: Array.from(valueSet.values).join(", "),
    }));
  }

    const fetchGridData = async (offset) => {

    try {
      const pageSize = 5;
            const filters = convertFilters(selectedFilters);
        
            const result = await getPatients(offset, filters);


      if (Array.isArray(result)) {
  setPatients((prev) => (offset === 1 ? result : [...prev, ...result]));
  setHasMore(result.length === pageSize);

      } else {
        console.error("Expected result to be an array, but got:", result);
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setHasMore(false);
    }
  };


  const fetchNextData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
  };

    useEffect(() => {
      getPatients([]);
      setPage(1);
      setHasMore(true);
      fetchGridData(1); 
    }, [selectedFilters]);

useEffect(() => {
  if (hasMore) {
    fetchGridData(page);
  }
}, [page]);

  useEffect(() => {
 
}, [selectedFilters]);
  

  const getInitialsBg = (index) => {
    const colors = [
      "linear-gradient(135deg, #f472b6, #ec4899)",
      "linear-gradient(135deg, #a855f7, #9333ea)",
      "linear-gradient(135deg, #60a5fa, #3b82f6)",
      "linear-gradient(135deg, #22d3ee, #06b6d4)",
      "linear-gradient(135deg, #34d399, #10b981)",
      "linear-gradient(135deg, #facc15, #eab308)",
      "linear-gradient(135deg, #fb923c, #f97316)",
      "linear-gradient(135deg, #f87171, #ef4444)",
      "linear-gradient(135deg, #818cf8, #6366f1)",
    ];
    return colors[index % colors.length];
  };

  if (isLoading || isFetching) {
    return (
      <div className="flex justify-center items-center h-[30rem]">
        <PulseLoader />
      </div>
    );
  }

  if (patients.length === 0) {
    return (
      <div className="min-h-[400px] flex flex-col items-center justify-center">
        <img
          src="/Images/doctortable.png"
          alt="No patients"
          className="w-[400px] h-auto mb-4"
        />
        <p className="text-gray-500 text-sm">No patients available</p>
      </div>
    );
  }

  return (
    
        
          <InfiniteScroll
  dataLength={patients?.length} 
  next={fetchNextData}
  hasMore={hasMore}
  loader={<h4>Loading...</h4>}
  endMessage={
    <p style={{ textAlign: 'center' }}>
      <b>Yay! You have seen it all</b>
    </p>
  }
  scrollableTarget="scrollableDiv"
>
  <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-9xl mx-auto">
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
   {patients?.map((patient, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-visible  mb-3"
            >
              {/* Action Icons */}
              <div className="absolute top-3 right-3 flex space-x-1">
                <button className="p-1.5 bg-white/20 hover:bg-white/30 rounded-full backdrop-blur-sm transition-all">
                  <svg
                    className="w-3 h-3 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  </svg>
                </button>
              </div>

              {/* Patient ID */}
              <div className="absolute -top-5 left-4 z-20">
                <div className="bg-white px-3 py-1 rounded-full shadow-md border border-gray-200">
                  <span className="text-xs font-semibold text-gray-700">
                    #{patient.patientIDUniqueID}
                  </span>
                </div>
              </div>

              {/* Card Content */}
              <div className="p-4 pt-4 relative">
                {/* Avatar */}
                <div className="flex items-center space-x-3 mb-4">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg"
                    style={{ background: getInitialsBg(index) }}
                  >
                    <span className="text-white font-bold text-lg">
                      {patient.fullName?.charAt(0) || "P"}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-900 truncate">
                      {patient.fullName}
                    </h3>
                    <p className="text-sm text-gray-500 truncate">
                      {patient.age} years old
                    </p>
                  </div>
                </div>

                {/* Status */}
                <div className="mb-4">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border bg-green-100 text-green-800 border-green-200">
                    <div className="w-1.5 h-1.5 rounded-full mr-1.5 bg-green-500"></div>
                    Active
                  </span>
                </div>

                {/* Patient Info */}
                <div className="space-y-3">
                  {/* Check-In Date */}
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <div className="w-4 h-4 bg-gradient-to-r from-[#7ceaae] to-[#38b286] rounded-full flex items-center justify-center">
                      <FiClock />
                    </div>
                    <span>
                      {patient?.insertedDate
                        ? new Date(patient.insertedDate)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .replace(/ /g, "-")
                        : "N/A"}
                    </span>
                  </div>

                  {/* Phone Number */}
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <div className="w-4 h-4 bg-gradient-to-r from-[#7ceaae] to-[#38b286] rounded-full flex items-center justify-center">
                      <FiPhone />
                    </div>
                    <span className="flex-1 truncate">
                      {patient.emergencyContactNumber || "No contact"}
                    </span>
                  </div>

                  {/* Gender */}
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <div className="w-4 h-4 bg-gradient-to-r from-[#7ceaae] to-[#38b286] rounded-full flex items-center justify-center">
                      {patient.gender?.toLowerCase() === "female" ? (
                        <FiSmile />
                      ) : (
                        <FiUser />
                      )}
                    </div>
                    <span className="capitalize">
                      {patient.gender || "Not specified"}
                    </span>
                  </div>
                </div>

                {/* View Button */}
                <div className="mt-3 pt-4 border-t border-gray-100">
                  <button
                    onClick={() =>
                      navigate(`/ClinicPatientView/${patient.userUniqueID}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`)
                    }
                    className="w-full text-white font-semibold py-2.5 rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 shadow-md"
                    style={{
                      background:
                        "linear-gradient(135deg, #7ceaae 0%, #53c898 50%, #38b286 100%)",
                    }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
          </div>
          </div>
          </div>
</InfiniteScroll>
    
  );
}

export default ClinicPatientsGrid;
